import React from 'react';
import { useIntl } from 'react-intl';
import { Image } from 'semantic-ui-react';
import poweredByAridhia from '@/assets/images/powered-by-aridhia.svg';

const HomeFooterLogo = () => {
  const intl = useIntl();
  return (
    <Image
      className="ui image logo float-r mt-10 pb-20 aridhia-powered small"
      src={poweredByAridhia}
      alt={intl.formatMessage({ id: 'home.footer.powered.alt' })}
    />
  );
};

export default HomeFooterLogo;
